// extracted by mini-css-extract-plugin
module.exports = {"logo":"OOLogo_logo__1Zzj7"};